<template>
  <b-overlay
      :show="showOverlay"
      rounded="sm"
  >

    <div v-if="products !== null">

      <!-- Table Container Card -->
      <b-card
          no-body
          class="mb-3"
      >

        <h1 class="m-2">لیست محصولات</h1>

        <div class="product-filters m-2">
          <b-form-group label="جستجوی محصول" label-for="blocked-product-search" class="mb-2">
            <b-form-input
                id="blocked-product-search"
                v-model="searchCommand"
                placeholder="جستجو بر اساس نام محصول..."
            />
          </b-form-group>

          <div class="product-filters-heading">
            <div class="d-flex align-items-center">
              <span class="font-weight-bold">فیلتر محصولات</span>
              <b-badge v-if="activeFilterCount" variant="light-primary" class="mr-1">
                {{ activeFilterCount }} فیلتر فعال
              </b-badge>
            </div>
            <b-button
                size="sm"
                variant="flat-secondary"
                :disabled="!activeFilterCount"
                @click="resetFilters"
            >پاک کردن فیلترها</b-button>
          </div>

          <b-row>
            <b-col v-for="filter in productFilters" :key="filter.key" cols="12" lg="6" class="mb-1">
              <div class="product-filter-card" :class="{ 'is-active': filters[filter.key] }">
                <CustomSwitch
                    v-model="filters[filter.key]"
                    :label="filter.label"
                    :description="filter.description"
                />
              </div>
            </b-col>
          </b-row>
        </div>

        <b-table
            ref="refUserListTable"
            class="position-relative"
            :items="products"
            responsive
            :fields="myTableColumns"
            primary-key="id"
            show-empty
            bordered
            striped
            empty-text="موردی موجود نیست!"
        >
          <template #cell(product.productId)="data">
            <b-media vertical-align="center">
              <template #aside>
                <b-avatar
                    size="45"
                    :src="`https://api.banafshebagheri.com/media/gallery/product/${data.item.product.imageFile}`"
                    :variant="`success`"
                />
              </template>
              <small class="text-muted">@{{ data.item.product.productId }}</small>
            </b-media>
          </template>

          <!-- Column: state -->
          <template #cell(state)="data">
            <b-badge
                v-if="isBlocked(data.item)"
                pill
                class="text-capitalize"
                :variant="`danger`"
            >
              مسدود شده
            </b-badge>
            <b-badge
                v-else
                pill
                class="text-capitalize"
                :variant="`success`"
            >
              مسدود نشده
            </b-badge>
          </template>


          <!-- Column: block -->
          <template #cell(block)="data">
            <b-form-checkbox
                :checked="isBlocked(data.item)"
                name="check-button"
                @change="switchState($event, data.item)"
                switch
                inline
            >
            </b-form-checkbox>
          </template>

          <template #cell(isRemoved)="data">
            <b-badge :variant="isRemoved(data.item) ? 'danger' : 'success'" pill>
              {{ isRemoved(data.item) ? 'حذف شده' : 'حذف نشده' }}
            </b-badge>
          </template>

          <template #cell(remove)="data">
            <b-form-checkbox
                :checked="isRemoved(data.item)"
                name="remove-check-button"
                @change="switchRemove($event, data.item)"
                switch
                inline
            >
            </b-form-checkbox>
          </template>

        </b-table>

        <div class="mx-2 mb-2">
          <b-row>

            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
            </b-col>
            <!-- Pagination -->
            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                  v-model="currentPage"
                  :total-rows="totalCounts"
                  :per-page="perPage"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon style="transform: rotate(180deg)"
                                icon="ChevronLeftIcon"
                                size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                  />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>

        <div class="mx-2 mb-2">
          <b-form-group
              label="توضیحات"
              label-for="description"
          >
            <b-form-textarea
                id="description"
                v-model="toggleData.description"
            />
          </b-form-group>
        </div>

        <div class="mx-4 mb-2">
          <b-row>
            <b-button
                variant="primary"
                class="mt-1 mb-sm-0 mr-0 mr-sm-1 col-12 col-md-2"
                :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                :disabled="!hasPendingChanges || showOverlay"
                @click="submitToggles"
            >
              ثبت
            </b-button>
          </b-row>
        </div>
      </b-card>
    </div>
  </b-overlay>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination, BOverlay, BFormCheckbox, BFormTextarea, BFormGroup
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import CustomSwitch from '@/views/components/utils/CustomSwitch.vue'
import Helper from "@/libs/Helper";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import {
  UserProductBlockGetBlockedProductsRequest,
  UserProductBlockToggleProductBlockRequest,
  UserProductBlockToggleProductRemoveRequest
} from "@/libs/Api/UserProductBlock";

export default {
  title: "مسدودسازی کاربر - پنل ادمین بنفشه باقری",
  name: "UserBlock",
  data() {
    return {
      userId: this.$route.params.id,
      products: null,
      showOverlay: false,
      currentPage: 1,
      totalCounts: null,
      perPage: 10,
      filters: {
        onlyBlocks: false,
        onlyRemoved: false,
      },
      productFilters: [
        { key: 'onlyBlocks', label: 'مسدودشده‌ها', description: 'فقط محصولات مسدودشدهٔ این کاربر' },
        { key: 'onlyRemoved', label: 'حذف‌شده‌ها', description: 'فقط محصولاتی که دسترسی‌شان حذف شده' },
      ],
      toggleData: {
        blockedProductIds: [],
        unblockedProductIds: [],
        userId: Number(this.$route.params.id),
        description: ""
      },
      removedProductIds: [],
      restoredProductIds: [],
      perPageOptions: [10, 20, 30, 40, 50],
      myTableColumns: [
        {key: 'product.productId', label: 'شناسه محصول'},
        {key: 'product.title', label: 'نام محصول'},
        {key: 'state', label: 'وضعیت'},
        {key: 'block', label: 'مسدودسازی'},
        {key: 'isRemoved', label: 'وضعیت دسترسی'},
        {key: 'remove', label: 'حذف دسترسی'},
      ],
      searchCommand: '',
      isAddNewUserSidebarActive: false,
      Cart: [],
    }
  },
  computed: {
    activeFilterCount() {
      return Object.values(this.filters).filter(Boolean).length;
    },
    hasPendingChanges() {
      return this.toggleData.blockedProductIds.length > 0 ||
          this.toggleData.unblockedProductIds.length > 0 ||
          this.removedProductIds.length > 0 ||
          this.restoredProductIds.length > 0;
    },
    CartTotal() {
      let result = 0;
      this.Cart.forEach((item) => {
        result += item.amount * item.count
      })
      return result;
    },
    currentDate() {
      let today = new Date();
      let date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
      let time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      return date + ' ' + time;
    },
  },
  async created() {
    await this.getProducts();
  },
  methods: {
    resetFilters() {
      this.filters = { onlyBlocks: false, onlyRemoved: false };
    },
    isBlocked(item) {
      const id = item.product.productId;
      if (this.toggleData.blockedProductIds.includes(id)) return true;
      if (this.toggleData.unblockedProductIds.includes(id)) return false;
      return item.state === true;
    },
    isRemoved(item) {
      const id = item.product.productId;
      if (this.removedProductIds.includes(id)) return true;
      if (this.restoredProductIds.includes(id)) return false;
      return item.isRemoved === true;
    },
    updateToggle(productId, checked, originalState, enabledIds, disabledIds) {
      const enabledIndex = enabledIds.indexOf(productId);
      if (enabledIndex !== -1) enabledIds.splice(enabledIndex, 1);
      const disabledIndex = disabledIds.indexOf(productId);
      if (disabledIndex !== -1) disabledIds.splice(disabledIndex, 1);

      if (checked !== originalState) {
        (checked ? enabledIds : disabledIds).push(productId);
      }
    },
    switchState(checked, item) {
      this.updateToggle(
          item.product.productId, checked, item.state === true,
          this.toggleData.blockedProductIds, this.toggleData.unblockedProductIds
      );
    },
    switchRemove(checked, item) {
      this.updateToggle(
          item.product.productId, checked, item.isRemoved === true,
          this.removedProductIds, this.restoredProductIds
      );
    },
    filterProducts() {
      if (this.currentPage !== 1) {
        this.currentPage = 1;
        return;
      }
      this.getProducts();
    },
    async getProducts() {
      let _this = this;
      _this.showOverlay = true;

      let getProductData = {
        pageNumber: _this.currentPage,
        count: _this.perPage,
        searchCommand: _this.searchCommand,
        userId: _this.$route.params.id,
        onlyBlocks: _this.filters.onlyBlocks,
        onlyRemoved: _this.filters.onlyRemoved,
      }

      let userProductBlockGetBlockedProductsRequest = new UserProductBlockGetBlockedProductsRequest(_this);
      userProductBlockGetBlockedProductsRequest.setParams(getProductData)
      await userProductBlockGetBlockedProductsRequest.fetch(function (content) {
        _this.showOverlay = false;
        _this.products = content.data;
        _this.totalCounts = content.totalCount;
      }, function (content) {
        _this.showOverlay = false;
        console.log(content)
      });
    },
    makePrettyPrice(param) {
      return Helper.prettyPrice(param, 0)
    },
    createJalaliDate(param) {
      return new Date(param).toLocaleDateString("fa-IR",);
    },
    async submitToggles() {
      if (!this.hasPendingChanges || this.showOverlay) return;

      this.showOverlay = true;
      let saved = false;

      if (this.toggleData.blockedProductIds.length || this.toggleData.unblockedProductIds.length) {
        const blockRequest = new UserProductBlockToggleProductBlockRequest(this);
        blockRequest.setData(this.toggleData);
        let success = false;
        await blockRequest.fetch(() => { success = true; }, () => {});
        if (!success) {
          this.showOverlay = false;
          return;
        }
        saved = true;
        this.toggleData.blockedProductIds = [];
        this.toggleData.unblockedProductIds = [];
      }

      if (this.removedProductIds.length || this.restoredProductIds.length) {
        const removeRequest = new UserProductBlockToggleProductRemoveRequest(this);
        removeRequest.setData({
          removedProductIds: this.removedProductIds,
          restoredProductIds: this.restoredProductIds,
          userId: Number(this.$route.params.id),
          description: this.toggleData.description,
        });
        let success = false;
        await removeRequest.fetch(() => { success = true; }, () => {});
        if (!success) {
          if (saved) await this.getProducts();
          this.showOverlay = false;
          return;
        }
        saved = true;
        this.removedProductIds = [];
        this.restoredProductIds = [];
      }

      if (saved) {
        this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            icon: 'CheckIcon',
            variant: 'success',
            text: `عملیات انجام شد.`,
          },
        });
        this.toggleData.description = '';
        await this.getProducts();
      }
      this.showOverlay = false;
    },
  }
  ,
  watch: {
    filters: {
      deep: true,
      handler() {
        this.filterProducts();
      },
    },
    perPage: function (nv, ov) {
      this.filterProducts();
    },
    currentPage: function (nv, ov) {
      this.getProducts();
    },
    searchCommand: function (nv, ov) {
      this.filterProducts();
    },
  },
  components: {
    CustomSwitch,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
    BFormCheckbox,
    BFormTextarea,
    BFormGroup,

    vSelect,
  }
  ,
}
</script>

<style lang="scss" scoped>
.product-filters-heading {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 12px;
}
.product-filter-card {
  height: 100%;
  padding: 16px;
  border: 1px solid rgba(130, 134, 139, .25);
  border-radius: 8px;
  transition: border-color .2s, background-color .2s;
}
.product-filter-card.is-active {
  border-color: var(--primary, #7367f0);
  background: rgba(115, 103, 240, .08);
}
.per-page-selector {
  width: 90px;
}
</style>
